export default {
  featuredExperiences: 'Наши лучшие впечатления',
  searchAllExperiences: 'Поиск всех впечатлений',
  searchAll: 'Искать все',
  groupSize: 'Размер группы',
  eventSize: 'Размер мероприятия',
  upTo: 'До',
  whatWeDo: 'Что мы будем делать',
  hostedBy: 'Организатор',
  whatsIncluded: 'Что включено',
  avail: 'Доступность',
  whereWeAre: 'Где мы будем',
  experienceCalendar: 'Календарь мероприятий',
  experienceCancelled: 'Мероприятие отменено',
  experienceStartingPrice: 'От {{price}}',
  experienceTotalPrice: 'Итого: {{price}}',
  at: 'в',
  viewPrivateSessAvailability: 'Просмотр доступности частных сеансов',
  selectSession: 'Выбрать сеанс',
  sessionsCount: '{{count}} времён — выберите время',
  noAvailability: 'Нет доступности',
  select: 'Выбрать',
  slotLeft: '{{remainSlots}} остался слот',
  slotsLeft: '{{remainSlots}} осталось слотов',
  spotsLeft: 'Осталось {{count}}',
  spotsLeftAriaLabel: 'Осталось {{count}} мест',
  bookExperience: 'Забронировать впечатление',
  book: 'Забронировать',
  learnMore: 'Подробнее',
  apply: 'Применить',
  maxPartySizes: 'Максимум {{maxGroupSize}} мест в группе',
  maxPartySize: 'Максимум {{maxGroupSize}} место в группе',
  selectSessionValidation: 'Пожалуйста, выберите сеанс',
  selectParticipantValidation: 'Пожалуйста, выберите участников',
  selectDateValidation: 'Пожалуйста, выберите дату',
  reminders: 'Напоминания',
  seeOtherDates: 'Посмотреть другие даты',
  location: 'Местоположение',
  about: 'Об этом',
  allExperiences: 'Все впечатления',
  soldOut: 'Продано',
  reviews: 'Отзывы',
  reviewSingular: 'отзыв',
  reviewPlural: 'отзывов',
  dateOfExperience: 'Дата впечатления',
  readLess: 'Скрыть',
  readMore: 'Читать далее',
  seeMore: 'Смотреть больше',
  details: 'Детали',
  durationHour: 'час',
  durationHours: 'часа',
  durationMinutes: 'мин',
  theFollowingVideoDoesNotContainAnyAudio: 'Следующее видео не содержит аудио',
  by: 'От',
  chooseATime: 'Выберите время для {{title}}',
  amenities: 'Удобства',
  ticketSalesOpenIn: 'Продажа билетов начнется через',
  ticketSalesOpen: 'Продажа билетов открыта',
  ticketSalesCloseIn: 'Продажа билетов закончится через',
  ticketSalesClose: 'Продажа билетов завершена',
  ticketSalesClosed: 'Продажа билетов закрыта',
  comingSoon: 'Скоро в продаже',
  inPartnershipWith: 'В партнерстве с',
  notFoundExperienceTitle: 'Этот опыт больше недоступен',
  notFoundExperienceSubtitle:
    'Возможно, он был снят с публикации или ссылка больше недействительна.',
  deadLinkRecoverySubtitle:
    'Откройте для себя другие впечатления, доступные для бронирования',
  viewAllExperiences: 'Посмотреть все впечатления',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Заработайте по 5 базовых баллов</strong> за каждый доллар США, потраченный на соответствующее критериям бронирование этой услуги с авторизацией в своей учетной записи World of Hyatt</p>',
      basePoints:
        '<p><strong>Заработайте по 10 базовых баллов</strong> за каждый доллар США, потраченный на соответствующее критериям бронирование этой услуги с авторизацией в своей учетной записи World of Hyatt</p>',
      additionalBonusPoints:
        '<p><strong>Зарабатывайте по 4 дополнительных бонусных балла</strong> за каждый доллар США, потраченный при соответствующем критериям бронировании по кредитной карте World of Hyatt</p>',
      additionalBonusPointsTier:
        '<p><strong>Получайте до 30% дополнительных бонусных баллов</strong> в зависимости от своего статуса</p>',
      payWithPoints:
        '<p><strong>Оплатите баллами</strong> бронирование этой услуги</p>',
    },
  },
};
